import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Menu from "./components/Menu";
import Footer from "./components/Footer";

import ConversionPage from "./Pages/ConversionPage";
import ReductionPage from "./Pages/ReductionPage";
import MentionsLegales from "./Pages/MentionsLegales";
import Confidentialite from "./Pages/Confidentialite";
import Conditions from "./Pages/Conditions";
import CookieBanner from "./components/CookieBanner";
import FaqPage from "./Pages/FaqPage";
import HomePage from "./Pages/HomePage";
import PdfToJpgPage from "./Pages/PdfToJpgPage";
import PdfToPngPage from "./Pages/PdfToPngPage";
import JpgToPdfPage from "./Pages/JpgToPdfPage";
import useOrganizationJsonLd from "./seo/useOrganizationJsonLd";
import AboutPage from "./Pages/AboutPage";
import FusionPage from "./Pages/FusionPage";

export default function App() {
  useOrganizationJsonLd();
  return (
    <div className="app-layout">
      <Menu />

      <main className="app-content">
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/pdf-jpg" element={<PdfToJpgPage />} />
          <Route path="/pdf-png" element={<PdfToPngPage />} />
          <Route path="/jpg-pdf" element={<JpgToPdfPage />} />
          <Route path="/conversion" element={<ConversionPage />} />
          <Route path="/reduction" element={<ReductionPage />} />
          <Route path="/fusion" element={<FusionPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/conditions" element={<Conditions />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="*" element={<Navigate to="/conversion" replace />} />
        </Routes>
      </main>
      <CookieBanner adsenseClientId="ca-pub-4717440096189113" />
      <Footer />
    </div>
  );
}
